module.exports = "<input type=\"checkbox\" class=\"hide\" checked=\"checked\"> <aside class=\"overlay\" (click)=\"onClose.emit()\" *ngIf=\"open\"> <div class=\"overlay__content modal\" [class.overflows]=\"overflows\" (click)=\"$event.stopPropagation()\"> <ng-content></ng-content> </div> </aside> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/modal.component.html
// module id = ./src/app/shared/components/modal/modal.component.html
// module chunks = 21